import { useTranslation } from 'react-i18next';
import InternalContainer from '../../Components/InternalContainer';
import CardExternalResource from '../../Components/CardExternalResource';

const booksData = [
	{
		id: 1,
		title: 'Jones & Bartlett Learning',
		url: 'https://www2.jblearning.com/my-account/dashboard/products',
		credentials: {
			name: 'librarian@aquinasnetwork.com',
			password: 'Olib1234$',
		},
	},
	{
		id: 2,
		title: 'American Heart Association',
		url: 'https://ebooks.heart.org/es/bookshelf',
		credentials: {
			name: 'librarian@aquinasnetwork.com',
			password: 'Olib1234$',
		},
	},
];

const ExternalResources = () => {
	const { t } = useTranslation();

	return (
		<main className='mt-[100px] min-h-[calc(100vh-100px)] bg-[#f0f0f0] pt-6 pb-12'>
			<InternalContainer>
				<h1 className='text-2xl font-bold text-slate-900 mb-8'>
					{t('NAEMT / AHA Resources')}
				</h1>

				<div className='grid grid-cols-[repeat(auto-fit,minmax(260px,1fr))] gap-4 md:gap-5'>
					{booksData.map((book) => (
						<CardExternalResource
							key={book.id}
							title={book.title}
							description={t(book.descriptionKey)}
							url={book.url}
							credentials={book.credentials}
							termsAndConditions={t('OMI Terms and Conditions Full Text')}
						/>
					))}
				</div>
			</InternalContainer>
		</main>
	);
};

export default ExternalResources;
